<template>
  <div class="table-count">
    <el-dropdown trigger="click" @command="init">
      <div>
        <span v-if="numberTxt ===''" class="el-dropdown-link">{{'自动计算'}}</span>
        <div v-else class="number-txt">
          <span>{{downList[active]}}：</span>
          <span class="number-val">{{numberTxt}}</span>
        </div>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item :command="index" v-for="(item,index) in downList" :key="item">{{item}}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import Vue from 'vue'
import bus from '@/bus'
export default {
  props: ['dataset', 'id', 'editItem', 'code'],
  data() {
    return {
      countArr: [],
      downList: ['不展示', '已填写项', '总和', '平均数', '中位数', '最小', '最大', '范围差'],
      numberTxt: '',
      active: 0,
      decimal_places: 2,
      currency: '¥'
    }
  },
  watch: {
    dataset: {
      handler() {
        this.active = 0
        this.restData()
      },
      deep: true
    }
  },
  created() {
    if (!this.isNeedComputed()) {
      this.downList = ['不展示', '已填写项']
    }
    this.active = 0
  },
  mounted() {
    // this.init(this.active)
  },
  methods: {
    isNeedComputed() {
      return this.code && (this.code === 'TaskComponent.Number.Normal' || this.code === 'TaskComponent.Number.Money')
    },
    restData() {
      this.numberTxt = ''
      this.countArr = []
      // this.init(this.active)
    },
    init(data) {
      this.handleCommand(data)
    },
    getKeyNumberCount() {
      return this.dataset.reduce((pre,n) => {
        return pre + (Array.isArray(n[this.code]) ? (n[this.code].length > 0 ? 1 : 0) : 1)
      },0)
    },
    getAutoKeyNumberCount() {
      let result = 0;
      this.dataset.forEach((res) => {
        let key = res.template.template_standard_components.find((item) => item.id == this.id);
        if (key.value) {
          result = result + 1;
        }
      });
      return result;
    },
    handleCommand(data) {
      if (this.isNeedComputed()) { // 数字、货币
        return this.allList(data)
      } else { // 其他
        return this.autoList(data)
      }
    },
    autoList(data) {
      this.active = data
        console.log('--------nnnnn-----------', this.numberTxt)
      switch (data) {
        case 0:
          this.active = 0
          this.restData()
          break
        case 1:
          if(!this.id) {
            this.numberTxt = this.getKeyNumberCount()
          } else {
            this.numberTxt = this.getAutoKeyNumberCount()
          }
      }
    },
    allList(data) {
      this.active = data
      this.countArr = []
      let tree = (key) => {
        for (let i = 0; i < key.length; i++) {
          let item = key[i].template.template_standard_components.find(res => res.id == this.id)
          let num = item.value || Vue['$' + item.component_code].getDefaultValue(item.component_values)
          if (num !== undefined) {
            this.countArr.push(num * 1)
          }
          if (key[i].children) {
            tree(key[i].children)
          }
        }
      }
      let key = this.dataset[0].template.template_standard_components.find(res => res.id == this.id)
      this.decimal_places = key.component_config_in_template.decimal_places
      this.currency = key.component_config_in_template.currency || ''
      tree(this.dataset)
      let n
      switch (data) {
        case 0:
          this.active = ''
          this.restData()
          break
        case 1:
          this.numberTxt = this.getAutoKeyNumberCount()
          break
        case 2:
          n = this.countArr.reduce((totle, num) => {
            return totle + num
          }, 0)
          this.numberTxt = this.currency + this.getZeroNum(n, this.decimal_places || 2)
          break
        case 3:
          let totle = this.countArr.reduce((totle, num) => {
            return totle + num
          }, 0)
          this.numberTxt = this.currency + this.getZeroNum(totle ? (totle / this.countArr.length).toFixed(2) : 0, this.decimal_places || 2)
          break
        case 4:
          let slortArr = JSON.parse(JSON.stringify(this.countArr))
          slortArr.sort() //排序
          if (slortArr.length % 2 === 0) { //判断数字个数是奇数还是偶数
            this.numberTxt = this.currency + this.getZeroNum(((slortArr[slortArr.length / 2] + slortArr[slortArr.length / 2 - 1]) / 2) || 0, this.decimal_places || 2)//偶数个取中间两个数的平均数
          } else {
            this.numberTxt = this.currency + this.getZeroNum(slortArr[parseInt(slortArr.length / 2)] || 0, this.decimal_places || 2)//奇数个取最中间那个数
          }
          break
        case 5:
          n = 0
          this.countArr.forEach((res, index) => {
            if (index === 0) {
              n = res
            } else if (res < n) {
              n = res
            }
          })
          this.numberTxt = this.currency + this.getZeroNum(n, this.decimal_places || 2)
          break
        case 6:
          n = 0
          this.countArr.forEach((res, index) => {
            if (index === 0) {
              n = res
            } else if (res > n) {
              n = res
            }
          })
          this.numberTxt = this.currency + this.getZeroNum(n, this.decimal_places || 2)
          break
        case 7:
          let max = ''
          let min = ''
          this.countArr.forEach((res, index) => {
            if (index === 0) {
              min = res
            } else {
              if (res < min) {
                min = res
              }
              if (res > max) {
                max = res
              }
            }
          })
          console.log('min-', min, 'max-', max)
          this.numberTxt = this.currency + this.getZeroNum(max - min, this.decimal_places || 2)
          break
      }
    }
  }
}
</script>

<style lang="scss">
.table-count {
  // margin-left: 10px;
  .number-txt {
    font-size: 12px;
    padding-right: 8px;
    cursor: pointer;
    span:nth-child(1) {
      color: #999;
    }
    .number-txt {
      font-weight: bold;
    }
    &:hover {
      span {
        color: $color-active !important;
      }
    }
  }
  .el-dropdown-link {
    visibility: hidden;
    color: #509aff !important;
    font-size: 14px !important;
    padding: 0;
  }
  &:hover {
    .el-dropdown-link {
      visibility: visible;
    }
  }
}
</style>
